import i18n from "@/i18n";
import { getLanguageCodeFrom } from "@/utils/locales";

export default {
  namespaced: true,

  state: {
    /**
     * Stores the actual language.
     * Initializes from i18n's detected language.
     */
    language: i18n.language,
  },

  mutations: {
    /**
     * Set language
     * @param {object} state Vuex state
     * @param {string} language
     */
    setLanguage(state, language) {
      state.language = language;
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("setLanguage", language);
      const locale = getLanguageCodeFrom(language);
      i18n.changeLanguage(locale);
    },
    refreshLanguage({ getters }) {
      const locale = getLanguageCodeFrom(getters.language);
      i18n.changeLanguage(locale);
    },
  },
  getters: {
    language(state) {
      return state.language;
    },
    isRTLLanguage(state) {
      return !!state.language?.startsWith("ar");
    },
    languageDirection(state, getters) {
      return getters.isRTLLanguage ? "rtl" : "ltr";
    },
  },
};
